import { ProductIdPrice } from '~/Api/ProductPrice';

export enum ActionType {
	request = 'ProductPrice.request',
	receive = 'ProductPrice.receive',
	pruneAll = 'ProductPrice.pruneAll',
	updateHideTooltipPreference = 'ProductPrice.updateHideTooltipPreference',
}

interface RequestAction {
	type: ActionType.request;
	request: Promise<any>;
	productIds: string[];
	currency: string | null;
	groupId: string | null;
}

interface ReceiveAction {
	type: ActionType.receive;
	request: Promise<any>;
	currency: string | null;
	items: ProductIdPrice[] | null;
}

interface PruneAllAction {
	type: ActionType.pruneAll;
}

interface UpdateHideTooltipPreferenceAction {
	type: ActionType.updateHideTooltipPreference;
}

export type Action = RequestAction | ReceiveAction | PruneAllAction | UpdateHideTooltipPreferenceAction;
